<template>
  <section
    class="rno-2-section rno-certificate-section"
    style="padding-top: 0;"
  >
    <div class="rno-section-inner">
      <div class="rno-section-hd">
        <h3 class="rno-section-tit">可靠，安全，合规的云服务</h3>
        <h3 class="rno-section-tit mobile">可靠，安全，合规的云服务</h3>
        <div class="rno-section-des"><span>获得众多合规认证</span></div>
      </div>
      <div class="rno-section-bd">
        <div class="home-certificate-list-pc">
          <ul class="home-certificate">
            <li class="home-certification-item">
              <a
                hotrep="home.cert.list.iso-27001"
                href="/document/product/363/2408"
              >
                <div class="home-certification-icon">
                  <img
                    src="//cloudcache.tencent-cloud.com/open_proj/proj_qcloud_v2/gateway/portal/css/img/home2017/certification/27001.png"
                    alt="ISO 27001"
                  />
                </div>
                <h4 class="home-certification-tit">ISO 27001</h4>
              </a>
            </li>
            <li class="home-certification-item">
              <a
                hotrep="home.cert.list.netsec"
                href="/document/product/363/2487"
              >
                <div class="home-certification-icon">
                  <img
                    src="//mc.qcloudimg.com/static/img/892b719278ec7feb4d43e29c953a5406/DJCP.png"
                    alt="<i>网络安全</i>等级保护 2.0"
                  />
                </div>
                <h4 class="home-certification-tit">
                  <i>网络安全</i>等级保护 2.0
                </h4>
              </a>
            </li>
            <li class="home-certification-item">
              <a
                hotrep="home.cert.list.trucs"
                href="/document/product/363/2411"
              >
                <div class="home-certification-icon">
                  <img
                    src="//cloudcache.tencent-cloud.com/open_proj/proj_qcloud_v2/gateway/portal/css/img/home2017/certification/trucs.png"
                    alt="可信云"
                  />
                </div>
                <h4 class="home-certification-tit">可信云</h4>
              </a>
            </li>
            <li class="home-certification-item">
              <a
                hotrep="home.cert.list.dca"
                href="//cloud.tencent.com/document/product/363/3964"
              >
                <div class="home-certification-icon">
                  <img
                    src="//cloudcache.tencent-cloud.com/open_proj/proj_qcloud_v2/gateway/portal/css/img/home2017/certification/big-data.png"
                    alt="<i>大数据产品</i>能力认证"
                  />
                </div>
                <h4 class="home-certification-tit">
                  <i>大数据产品</i>能力认证
                </h4>
              </a>
            </li>
            <li class="home-certification-item">
              <a hotrep="home.cert.list.csa" href="/document/product/363/7249">
                <div class="home-certification-icon">
                  <img
                    src="//mc.qcloudimg.com/static/img/2053f0bd6af500561c1cbca2f1c292af/CSA+STAR.png"
                    alt="<i>CSA STAR</i>金牌认证"
                  />
                </div>
                <h4 class="home-certification-tit"><i>CSA STAR</i>金牌认证</h4>
              </a>
            </li>
            <li class="home-certification-item">
              <a
                hotrep="home.cert.list.CISPE"
                href="/document/product/363/20373"
              >
                <div class="home-certification-icon">
                  <img
                    src="https://main.qcloudimg.com/raw/67bc2e10c8921144f0f998bfab4a777b.png"
                    alt="<i>CISPE</i>认证"
                  />
                </div>
                <h4 class="home-certification-tit"><i>CISPE</i>认证</h4>
              </a>
            </li>
            <li class="home-certification-item">
              <a hotrep="home.cert.list.soc" href="/document/product/363/11543">
                <div class="home-certification-icon">
                  <img
                    src="//mc.qcloudimg.com/static/img/980f144b762befc6bf7954b483c84627/AICPA+SOC.png"
                    alt="<i>SOC</i>鉴证审计"
                  />
                </div>
                <h4 class="home-certification-tit"><i>SOC</i>鉴证审计</h4>
              </a>
            </li>
            <li class="home-certification-item">
              <a hotrep="home.cert.list.more" href="/service/compliance">
                <div class="home-certification-icon more"></div>
                <h4 class="home-certification-tit">查看更多</h4>
              </a>
            </li>
          </ul>
        </div>
        <div class="home-certificate-list-mobile">
          <ul class="home-certificate">
            <li class="home-certification-item">
              <a
                hotrep="home.cert.list.iso-27001"
                href="/document/product/363/2408"
              >
                <div class="home-certification-icon">
                  <img
                    src="//cloudcache.tencent-cloud.com/open_proj/proj_qcloud_v2/gateway/portal/css/img/home2017/certification/27001.png"
                    alt="ISO 27001"
                  />
                </div>
                <h4 class="home-certification-tit">ISO 27001</h4>
              </a>
            </li>
            <li class="home-certification-item">
              <a
                hotrep="home.cert.list.netsec"
                href="/document/product/363/2487"
              >
                <div class="home-certification-icon">
                  <img
                    src="//mc.qcloudimg.com/static/img/892b719278ec7feb4d43e29c953a5406/DJCP.png"
                    alt="<i>网络安全</i>等级保护 2.0"
                  />
                </div>
                <h4 class="home-certification-tit">
                  <i>网络安全</i>等级保护 2.0
                </h4>
              </a>
            </li>
            <li class="home-certification-item">
              <a
                hotrep="home.cert.list.trucs"
                href="/document/product/363/2411"
              >
                <div class="home-certification-icon">
                  <img
                    src="//cloudcache.tencent-cloud.com/open_proj/proj_qcloud_v2/gateway/portal/css/img/home2017/certification/trucs.png"
                    alt="可信云"
                  />
                </div>
                <h4 class="home-certification-tit">可信云</h4>
              </a>
            </li>
            <li class="home-certification-item">
              <a
                hotrep="home.cert.list.dca"
                href="//cloud.tencent.com/document/product/363/3964"
              >
                <div class="home-certification-icon">
                  <img
                    src="//cloudcache.tencent-cloud.com/open_proj/proj_qcloud_v2/gateway/portal/css/img/home2017/certification/big-data.png"
                    alt="<i>大数据产品</i>能力认证"
                  />
                </div>
                <h4 class="home-certification-tit">
                  <i>大数据产品</i>能力认证
                </h4>
              </a>
            </li>
            <li class="home-certification-item">
              <a hotrep="home.cert.list.csa" href="/document/product/363/7249">
                <div class="home-certification-icon">
                  <img
                    src="//mc.qcloudimg.com/static/img/2053f0bd6af500561c1cbca2f1c292af/CSA+STAR.png"
                    alt="<i>CSA STAR</i>金牌认证"
                  />
                </div>
                <h4 class="home-certification-tit"><i>CSA STAR</i>金牌认证</h4>
              </a>
            </li>
            <li class="home-certification-item">
              <a
                hotrep="home.cert.list.CISPE"
                href="/document/product/363/20373"
              >
                <div class="home-certification-icon">
                  <img
                    src="https://main.qcloudimg.com/raw/67bc2e10c8921144f0f998bfab4a777b.png"
                    alt="<i>CISPE</i>认证"
                  />
                </div>
                <h4 class="home-certification-tit"><i>CISPE</i>认证</h4>
              </a>
            </li>
            <li class="home-certification-item">
              <a hotrep="home.cert.list.soc" href="/document/product/363/11543">
                <div class="home-certification-icon">
                  <img
                    src="//mc.qcloudimg.com/static/img/980f144b762befc6bf7954b483c84627/AICPA+SOC.png"
                    alt="<i>SOC</i>鉴证审计"
                  />
                </div>
                <h4 class="home-certification-tit"><i>SOC</i>鉴证审计</h4>
              </a>
            </li>
            <li class="home-certification-item">
              <a
                hotrep="home.cert.list.PCI DSS"
                href="https://cloud.tencent.com/document/product/363/11062"
              >
                <div class="home-certification-icon">
                  <img
                    src="https://main.qcloudimg.com/raw/1d2e97180feddb0f4b753d00fa7cf085.png"
                    alt="<i>PCI DSS</i>认证"
                  />
                </div>
                <h4 class="home-certification-tit"><i>PCI DSS</i>认证</h4>
              </a>
            </li>
          </ul>
          <div class="rno-more-link">
            <a
              class="rno-link rno-link-arrow"
              hotrep="home.cert.list.more"
              href="/service/compliance"
            >
              查看更多
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {}
</script>

<style></style>
